/**
 * WellnessFitWear Theme - Mobile Menu
 * Handles mobile menu toggle and navigation
 */

class MobileMenu {
    constructor() {
        this.menuToggle = document.querySelector('[data-menu-toggle]');
        this.menuClose = document.querySelector('[data-menu-close]');
        this.mobileMenu = document.querySelector('[data-mobile-menu]');
        this.body = document.body;

        this.init();
    }

    init() {
        if (!this.menuToggle || !this.mobileMenu) return;

        this.bindEvents();
    }

    bindEvents() {
        // Open menu
        this.menuToggle.addEventListener('click', () => {
            this.open();
        });

        // Close menu
        this.menuClose?.addEventListener('click', () => {
            this.close();
        });

        // Close on backdrop click
        this.mobileMenu.addEventListener('click', (e) => {
            if (e.target === this.mobileMenu) {
                this.close();
            }
        });

        // Close on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
                this.close();
            }
        });

        // Close menu on resize to desktop
        window.addEventListener('resize', () => {
            if (window.innerWidth > 992 && this.isOpen()) {
                this.close();
            }
        });
    }

    open() {
        this.mobileMenu.classList.add('is-open');
        this.body.style.overflow = 'hidden';
        this.menuToggle.setAttribute('aria-expanded', 'true');

        // Focus first menu item
        const firstLink = this.mobileMenu.querySelector('a');
        if (firstLink) {
            firstLink.focus();
        }
    }

    close() {
        this.mobileMenu.classList.remove('is-open');
        this.body.style.overflow = '';
        this.menuToggle.setAttribute('aria-expanded', 'false');
        this.menuToggle.focus();
    }

    isOpen() {
        return this.mobileMenu.classList.contains('is-open');
    }
}

/**
 * Header Sticky Behavior
 */
class StickyHeader {
    constructor() {
        this.header = document.querySelector('.header');
        this.lastScrollPosition = 0;
        this.threshold = 100;

        this.init();
    }

    init() {
        if (!this.header) return;

        window.addEventListener('scroll', () => {
            this.handleScroll();
        }, { passive: true });
    }

    handleScroll() {
        const currentScrollPosition = window.pageYOffset;

        if (currentScrollPosition > this.threshold) {
            this.header.classList.add('is-scrolled');
        } else {
            this.header.classList.remove('is-scrolled');
        }

        // Hide/show on scroll direction
        if (currentScrollPosition > this.lastScrollPosition && currentScrollPosition > 200) {
            this.header.classList.add('is-hidden');
        } else {
            this.header.classList.remove('is-hidden');
        }

        this.lastScrollPosition = currentScrollPosition;
    }
}

/**
 * Dropdown Menu (Desktop)
 */
class DropdownMenu {
    constructor() {
        this.menuItems = document.querySelectorAll('.header__menu-item');
        this.init();
    }

    init() {
        this.menuItems.forEach(item => {
            const dropdown = item.querySelector('.header__dropdown');
            if (!dropdown) return;

            // Keyboard accessibility
            const link = item.querySelector('.header__menu-link');
            link?.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dropdown.classList.toggle('is-open');
                }
            });

            // Close dropdown when focus leaves
            item.addEventListener('focusout', (e) => {
                if (!item.contains(e.relatedTarget)) {
                    dropdown.classList.remove('is-open');
                }
            });
        });
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
    new StickyHeader();
    new DropdownMenu();
});
